// frontend/src/components/WorkspaceSwitcher/WorkspaceSwitcher.jsx
import React from 'react';
import { Dropdown, Button, Tag } from 'antd';
import { TeamOutlined, DownOutlined, CheckOutlined } from '@ant-design/icons';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { useAuth } from '../../contexts/AuthContext';

function primeiroNome(nome) {
  return (nome || '').trim().split(/\s+/)[0] || 'conta';
}

export default function WorkspaceSwitcher({ isMobile }) {
  const { recebidos, workspaceAtivo, trocarWorkspace } = useWorkspace();
  const { acessoPermitido } = useAuth();

  if (!recebidos || recebidos.length === 0) return null;

  // Convidado sem assinatura própria só tem o espaço do titular.
  const contaPropria = acessoPermitido ? [
    {
      key: 'propria',
      label: (
        <span>
          {!workspaceAtivo && <CheckOutlined style={{ marginRight: 8 }} />}
          Minha conta
        </span>
      ),
      onClick: () => { if (workspaceAtivo) trocarWorkspace(null); },
    },
    { type: 'divider' },
  ] : [];

  const items = [
    ...contaPropria,
    ...recebidos.map((a) => ({
      key: String(a.titular?.id),
      label: (
        <span>
          {String(workspaceAtivo?.titular?.id) === String(a.titular?.id)
            && <CheckOutlined style={{ marginRight: 8 }} />}
          Conta de {a.titular?.nome}
        </span>
      ),
      onClick: () => {
        if (String(workspaceAtivo?.titular?.id) !== String(a.titular?.id)) {
          trocarWorkspace(a.titular?.id);
        }
      },
    })),
  ];

  const rotulo = workspaceAtivo
    ? `Conta de ${primeiroNome(workspaceAtivo.titular?.nome)}`
    : 'Minha conta';

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Button
        size={isMobile ? 'small' : 'middle'}
        type={workspaceAtivo ? 'primary' : 'default'}
        ghost={!!workspaceAtivo}
        icon={<TeamOutlined />}
      >
        {isMobile ? null : rotulo}{' '}
        {workspaceAtivo && isMobile && <Tag color="gold" style={{ margin: 0 }}>outra</Tag>}
        <DownOutlined style={{ fontSize: 10 }} />
      </Button>
    </Dropdown>
  );
}
